import React, { useState } from "react";
import { RotateCcw } from "lucide-react";
import Card from "./Card";
import Dialog from "./Dialog";
import { useLocalStorage } from "../hooks/useLocalStorage";

export default function EvenOddCard() {
  const [selected, setSelected] = useLocalStorage("evenOddCard.selected", null);
  const [range, setRange] = useLocalStorage("evenOddCard.range", 20);
  const [isEditOpen, setIsEditOpen] = useState(false);

  function clearSelection() {
    setSelected(null);
    setIsEditOpen(false);
  }

  return (
    <>
      <Card title="Even or Odd?" colorIndex={4} onEdit={() => setIsEditOpen(true)}>
        <div className="h-full flex flex-col gap-2 lg:gap-3 min-h-0 overflow-hidden">
          <div className="flex-1 grid grid-cols-5 gap-2 lg:gap-3 xl:gap-4 overflow-hidden auto-rows-fr">
            {Array.from({ length: range }, (_, i) => i + 1).map((n) => {
              const isEven = n % 2 === 0;
              const active = selected === n;
              return (
                <button
                  key={n}
                  onClick={() => setSelected(n)}
                  className={`rounded-lg lg:rounded-xl py-1 lg:py-2 xl:py-3 text-base lg:text-xl xl:text-2xl 2xl:text-3xl font-fredoka font-bold shadow border-2 lg:border-3 transition hover:scale-105 flex items-center justify-center min-h-0 ${
                    isEven ? "bg-blue-100 border-blue-300 hover:bg-blue-200" : "bg-red-100 border-red-300 hover:bg-red-200"
                  } ${active ? "ring-2 lg:ring-4 ring-yellow-300" : ""}`}
                >
                  {n}
                </button>
              );
            })}
          </div>
          <div className="text-center text-lg lg:text-xl xl:text-2xl 2xl:text-3xl font-fredoka font-bold py-2 flex-shrink-0">
            {selected ? (
              <span>
                {selected} is {selected % 2 === 0 ? "EVEN" : "ODD"}!
              </span>
            ) : (
              <span>Tap a number</span>
            )}
          </div>
        </div>
      </Card>

      <Dialog isOpen={isEditOpen} onClose={() => setIsEditOpen(false)} title="Edit Even or Odd">
        <div className="space-y-4">
          <div>
            <h3 className="font-bold mb-2">Number Range</h3>
            <div className="grid grid-cols-2 gap-2">
              <button 
                className={`px-3 py-2 rounded-lg font-bold shadow transition ${
                  range === 10 ? "bg-orange-300" : "bg-orange-200 hover:bg-orange-300"
                }`}
                onClick={() => setRange(10)}
              >
                1-10
              </button>
              <button 
                className={`px-3 py-2 rounded-lg font-bold shadow transition ${
                  range === 20 ? "bg-orange-300" : "bg-orange-200 hover:bg-orange-300"
                }`}
                onClick={() => setRange(20)}
              >
                1-20
              </button>
              <button 
                className={`px-3 py-2 rounded-lg font-bold shadow transition ${
                  range === 50 ? "bg-orange-300" : "bg-orange-200 hover:bg-orange-300"
                }`}
                onClick={() => setRange(50)}
              >
                1-50
              </button>
              <button 
                className={`px-3 py-2 rounded-lg font-bold shadow transition ${
                  range === 100 ? "bg-orange-300" : "bg-orange-200 hover:bg-orange-300"
                }`}
                onClick={() => setRange(100)}
              >
                1-100
              </button>
            </div>
          </div>

          {selected && (
            <div className="text-center p-3 bg-yellow-100 rounded-lg">
              <div className="font-bold text-lg">
                Currently selected: {selected} is {selected % 2 === 0 ? "EVEN" : "ODD"}
              </div>
            </div>
          )}

          <div>
            <button 
              className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg bg-slate-200 font-bold shadow hover:bg-slate-300 transition" 
              onClick={clearSelection}
            >
              <RotateCcw className="w-4 h-4" />
              Clear Selection
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
